import React from 'react';
import { Form, Icon, Message } from 'semantic-ui-react'
import _find from 'lodash/find';
import { List, Button } from 'semantic-ui-react'
import {graphql} from 'react-apollo';
import {flowRight as compose} from 'lodash';
import queries from '../../../utils/queries'
// import { List, Button, Form, Icon } from 'semantic-ui-react'
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import emailjs from 'emailjs-com'

import EstaSeg7Btn from '../../../components/funcionales/estaseg7btn';
import EstaSeguro from '../../../components/funcionales/estaseguro'

const DetalleNivelLista2 = ({styles, elementoI, handleChangeDes}) => {
  let porcDespacho=0, porcCompra=0
console.log(elementoI)
  const rango1Ini = (valor) => {
    console.log(valor)
    if(valor!==null){
      return valor
    }else{
      return ''
    }
  }

  if(elementoI.cantidadDespacho && elementoI.cantidadDespacho!=='' && elementoI.cantidadDespacho!==null && elementoI.cantidadDespacho>0){
    porcDespacho = (elementoI.cantidadDespacho*100)/elementoI.cantidadCoti
  }
  if(elementoI.cantidadCompra && elementoI.cantidadCompra!=='' && elementoI.cantidadCompra!==null && elementoI.cantidadCompra>0
    && elementoI.cantidadCompraEjec && elementoI.cantidadCompraEjec!=='' && elementoI.cantidadCompraEjec!==null && elementoI.cantidadCompraEjec>0){
    porcCompra = (elementoI.cantidadCompraEjec*100)/elementoI.cantidadCompra
  }

  return(
    <tr className=''>
      <td className='center aligned' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12,
              color: 'black', background: 'white'}}>{elementoI.cantidadCoti}</td>
      <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12,
              color: 'black', background: 'white'}}>{elementoI.descrUnidad}</td>
      <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12,
              color: 'black', background: 'white'}}>{elementoI.descrProducto}</td>
      <td className='center aligned' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12,
              color: 'black', background: 'white'}}>{elementoI.cantidadDespacho?new Intl.NumberFormat('de-DE').format(elementoI.cantidadDespacho):0}</td>
      <td className='center aligned' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12,
              color: 'black', background: 'white'}}>{new Intl.NumberFormat('de-DE').format(porcDespacho)}</td>
      <td className='center aligned' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12,
              color: 'black', background: 'white'}}>{elementoI.cantidadCompra?new Intl.NumberFormat('de-DE').format(elementoI.cantidadCompra):0}</td>
      <td className='center aligned' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12,
              color: 'black', background: 'white'}}>{elementoI.cantidadCompraEjec?new Intl.NumberFormat('de-DE').format(elementoI.cantidadCompraEjec):0}</td>
      <td className='center aligned' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12,
              color: 'black', background: 'white'}}>{new Intl.NumberFormat('de-DE').format(porcCompra)}</td>
      <td className='center aligned' style={styles.styPaddMarg}>
        <input type='number' step="1" min="0" autoComplete="off" name="nuevoValor" id={elementoI._id} value={rango1Ini(elementoI.nuevoValor)} placeholder='Cant. desp.' onChange={(ev)=>handleChangeDes(ev, elementoI)}/>
      </td>
      <td className='center aligned' style={styles.styPaddMarg}>
        <input type='number' step="1" min="0" autoComplete="off" name="nuevoValor2" id={elementoI._id} value={rango1Ini(elementoI.nuevoValor2)} placeholder='Solicitar compra' onChange={(ev)=>handleChangeDes(ev, elementoI)}/>
      </td>
      <td className='center aligned' style={styles.styPaddMarg}>
        <input type='number' step="1" min="0" autoComplete="off" name="nuevoValor4" id={elementoI._id} value={rango1Ini(elementoI.nuevoValor4)} placeholder='Registrar compra' onChange={(ev)=>handleChangeDes(ev, elementoI)}/>
      </td>
    </tr>
  )
};

const Lista2 = ({styles, listI, handleChangeDes}) => {
  console.log(listI)
  const nivel2Detalle = listI.map((elementoI, _id) => <DetalleNivelLista2 styles={styles} elementoI={elementoI} handleChangeDes={handleChangeDes} key={elementoI._id}/>);
  return(
    <tbody className=''>
      {nivel2Detalle}
    </tbody>
  )
};

const DetalleNivelLista3 = ({styles, elementoD, handleChangeDev}) => {
  const rango2Ini = (valor) => {
    if(valor!==null){
      return valor
    }else{
      return ''
    }
  }
console.log(elementoD)
    return(
    <tr className=''>
      <td className='center aligned' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12,
              color: 'black', background: 'white'}}>{elementoD.numDespacho}</td>
      <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12,
              color: 'black', background: 'white'}}>{elementoD.fechaDespacho?elementoD.fechaDespacho.substr(0, 10):""}</td>
      <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12,
              color: 'black', background: 'white'}}>{elementoD.descrProductoDes}</td>
      <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12,
              color: 'black', background: 'white'}}>{elementoD.descrUnidadDes}</td>
      <td className='center aligned' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12,
              color: 'black', background: 'white'}}>{elementoD.cantidad}</td>
      <td className='center aligned' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12,
              color: 'black', background: 'white'}}>{elementoD.cantidadDev?new Intl.NumberFormat('de-DE').format(elementoD.cantidadDev):0}</td>
      <td className='center aligned' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12,
              color: 'black', background: 'white'}}>{elementoD.cantidadDev?new Intl.NumberFormat('de-DE').format(elementoD.cantidad-elementoD.cantidadDev):new Intl.NumberFormat('de-DE').format(elementoD.cantidad)}</td>
      <td className='center aligned' style={styles.styPaddMarg}>
        <input type='number' step="1" min="0" autoComplete="off" name="nuevoValor2" id={elementoD._id} value={rango2Ini(elementoD.nuevoValor2)} placeholder='Cant. devuelta' onChange={(ev)=>handleChangeDev(ev, elementoD)}/>
      </td>
      <td className='center aligned' style={styles.styPaddMarg}>
        <input type='number' step="1" min="0" max="1" autoComplete="off" name="nuevoValor3" id={elementoD._id} value={rango2Ini(elementoD.nuevoValor3)} placeholder='Digite 1 para imprimir' onChange={(ev)=>handleChangeDev(ev, elementoD)}/>
      </td>
    </tr>
  )
};

const Lista3 = ({styles, listD, handleChangeDev}) => {
  console.log(listD)
  const nivel3Detalle = listD.map((elementoD, _id) => <DetalleNivelLista3 styles={styles} elementoD={elementoD} handleChangeDev={handleChangeDev} key={elementoD._id}/>);
  return(
    <tbody className=''>
      {nivel3Detalle}
    </tbody>
  )
};

class VerOrdenCompraFin2 extends React.Component {    
  state={lista6: [], lista5: this.props.list5, lista7: this.props.list7, ingresa: "S", crearUsu: "N",
    argsDocum: { file: "", file1: "", file2: "", file3: "", file4: "",
      descrEmpresa: this.props.idLista.descrEmpresa,
      numCoti: this.props.idLista.numCoti,
      // nombreUsuarioOC: this.props.idLista.nombreUsuarioOC,
      // nombreUsuarioOCNuevo: 'Seleccionar coordinador...',
      // cedulaOCNuevo: '',
      // estadoOC: this.props.idLista.estadoOC,
      // numOrdenCompra: this.props.idLista.numOrdenCompra,
      ordenCompraCliente: this.props.idLista.ordenCompraCliente?this.props.idLista.ordenCompraCliente:"",
      // tipo: this.props.idLista.tipo,
      observacionesFin: this.props.idLista.observacionesFin?this.props.idLista.observacionesFin:"",
      fechaFinReal: this.props.idLista.fechaFinReal?this.props.idLista.fechaFinReal:this.props.fechaHoy,
      // usuarioFin: this.props.idLista.usuarioFin?this.props.idLista.usuarioFin:"",
      // contactoEncuesta: this.props.idLista.contactoEncuesta?this.props.idLista.contactoEncuesta:"",
      // cedulaEncuesta: this.props.idLista.cedulaEncuesta?this.props.idLista.cedulaEncuesta:"",
      // telefonoEncuesta: this.props.idLista.telefonoEncuesta?this.props.idLista.telefonoEncuesta:"",
      // emailEncuesta: this.props.idLista.emailEncuesta?this.props.idLista.emailEncuesta:"",
      // actaInicial: this.props.idLista.actaInicial?this.props.idLista.actaInicial:"",
      // actaFinal: this.props.idLista.actaFinal?this.props.idLista.actaFinal:"",
      // archivoEncuesta: this.props.idLista.archivoEncuesta?this.props.idLista.archivoEncuesta:"",
      informe: this.props.idLista.informe?this.props.idLista.informe:"",
      // ordenPago: this.props.idLista.ordenPago?this.props.idLista.ordenPago:"",
      // valoracion: this.props.valoracionE?this.props.valoracionE:0,
      // valorFact: 0, totalFact: 0,
      totalOC: this.props.idLista.cantidadAprob?this.props.idLista.cantidadAprob:0,
      totalPago: this.props.idLista.cantidadRecibida?this.props.idLista.cantidadRecibida:0,
      dirEntrega: this.props.idLista.lugarEntrega?this.props.idLista.lugarEntrega:"",
      fechaEntrega: this.props.fechaHoy,
      transportadora: "",
      numGuia: "",
      emailAviso: this.props.idLista.emailEncuesta?this.props.idLista.emailEncuesta:"",
      _id: this.props.idLista._id
    },
    pendienteFact: 0,
    confirmaAct: false, preguntaE: "", permiteBtn1: true, permiteBtn2: true, procBtn: 0, checked: false, 
    open: false,
    argsQuery1: `{"$unwind": "$itemsCoti"},
    {$project: {_id: {$concat: ['$numCoti', '$descrProducto']}, 
        numCoti: 1, consecDespacho: 1, consecAvance: 1, descrEmpresa: 1, nombreUsuarioOC: 1, 
        mail: 1, ciudad: 1, contacto: 1, celular: 1, ordenCompraCliente: 1, nombreUsuario: 1, 
        nombreContacto: 1, ciudadContacto: 1, cargoContacto: 1, mailContacto: 1, telContacto: 1, lugarEntrega: 1, 
        numOrdenCompra: 1, tipoProducto: '$itemsCoti.tipoProducto',
        descrProducto: '$itemsCoti.descrProducto', 
        numProductoCoti: '$itemsCoti.numProductoCoti', 
        cantidadAprob: '$itemsCoti.cantidadAprob', 
        valorUniAprob: '$itemsCoti.valorUniAprob', 
        porcDcto: '$itemsCoti.porcDcto',
        porcIncremento: '$itemsCoti.porcIncremento',
        porcIVA: '$itemsCoti.porcIVA',
        descrUnidad: '$itemsCoti.descrUnidad',
        cantidadDespacho: '$itemsCoti.cantidadDespacho',
        cantidadFact: '$itemsCoti.cantidadFact',
        cantidadCompra: '$itemsCoti.cantidadCompra', cantidadCompraEjec: '$itemsCoti.cantidadCompraEjec'}},
    {$sort: {descrProducto: 1}}`,
    argsQuery2: `{"$unwind": "$itemsDespacho"},
    {$project: {numOrdenCompra: 1, 
        numDespacho: '$itemsDespacho.numDespacho', numCoti: 1, descrEmpresa: 1, nombreUsuarioOC: 1, 
        mail: 1, ciudad: 1, contacto: 1, celular: 1, ordenCompraCliente: 1, nombreUsuario: 1, 
        nombreContacto: 1, ciudadContacto: 1, cargoContacto: 1, mailContacto: 1, telContacto: 1, lugarEntrega: 1, 
        tipoProducto: '$itemsCoti.tipoProducto',
        fechaDespacho: '$itemsDespacho.fechaDespacho', 
        descrProductoDes: '$itemsDespacho.descrProductoDes', idProducto: '$itemsDespacho.idProducto', 
        descrUnidadDes: '$itemsDespacho.descrUnidadDes', 
        porcDctoDes: '$itemsDespacho.porcDctoDes',
        porcIncrementoDes: '$itemsDespacho.porcIncrementoDes',
        porcIVADes: '$itemsDespacho.porcIVADes',
        cantidad: '$itemsDespacho.cantidad',
        cantidadDev: '$itemsDespacho.cantidadDev',
        valorDes: '$itemsDespacho.valorDes',
        despFact:'$itemsDespacho.despFact'}},
    {$project: {_id: {$concat: ['$numCoti', '$descrProductoDes', '$despFact', '$numDespacho']}, 
        numCoti: 1, numOrdenCompra: 1, descrUnidadDes: 1, descrEmpresa: 1, descrProductoDes: 1, idProducto: 1, porcIVADes: 1, fechaDespacho: 1,
        nombreUsuarioOC: 1, mail: 1, ciudad: 1, contacto: 1, celular: 1, ordenCompraCliente: 1, nombreUsuario: 1, lugarEntrega: 1, 
        nombreContacto: 1, ciudadContacto: 1, cargoContacto: 1, mailContacto: 1, telContacto: 1, tipoProducto: 1,
        porcDctoDes: 1, porcIncrementoDes: 1, cantidad: 1,cantidadDev: 1,  numDespacho: 1, despFact: 1, valorDes: 1}},
    {$sort: {descrProductoDes: 1}}`
  }

  nextVal = async (name) => {
    const argsUpd = {
      coleccion: name,
    }
    const response = await this.props.editSeqfindOneAndUpdate({
      variables: argsUpd
    });
    return response.data.editSeqfindOneAndUpdate.seq
  }

  handleChange = (ev, argsDocum) => {
    if (this.props.permiteUpdate){
      this.setState({confirmaAct: false})
      const argsDocum = this.state.argsDocum
      let file3 = "", informe = ""

      if(ev.target.name==='file3'){
        file3 = ev.target.files[0]
        informe = ev.target.files[0].name
        argsDocum['informe'] = informe
        argsDocum['file3'] = file3
        console.log(argsDocum)
      }else{
        if(ev.target.name==="aprobarOC"){
          this.setState({checked: ev.target.checked})
        }else{
          argsDocum[ev.target.name] = ev.target.value
        }
      }
      
      console.log(argsDocum)
      this.setState({argsDocum});
      this.setState({ingresa: "N"})

    }
  }

  handleChangeDes = (ev, elemento) => {
    if(ev.target.name === "nuevoValor" || ev.target.name === "nuevoValor2" || ev.target.name === "nuevoValor4"){
      let listItem=this.state.lista5
      let cantDes=0, desPen=0, regPen=0, cantComp=0, cantCompraEjec=0
      let indexSearch=-1
      if(elemento.numProductoCoti && elemento.numProductoCoti!==null && elemento.numProductoCoti!==''){
        indexSearch = listItem.findIndex(buscaProducto => buscaProducto.numProductoCoti === elemento.numProductoCoti);
      }else{
        indexSearch = listItem.findIndex(buscaProducto => buscaProducto.descrProducto === elemento.descrProducto);
      }
      // const indexSearch = listItem.findIndex(buscaProducto => buscaProducto.descrProducto === elemento.descrProducto);
      if(indexSearch !== -1){
        if(ev.target.name === "nuevoValor"){
          if(!listItem[indexSearch].cantidadDespacho || listItem[indexSearch].cantidadDespacho=='' || listItem[indexSearch].cantidadDespacho==null || listItem[indexSearch].cantidadDespacho===0){
            cantDes=ev.target.value
            desPen=listItem[indexSearch].cantidadCoti
            listItem[indexSearch].cantidadDespacho = 0
          }else{
            cantDes=parseInt(listItem[indexSearch].cantidadDespacho + ev.target.value)
            desPen=parseInt(listItem[indexSearch].cantidadCoti - listItem[indexSearch].cantidadDespacho)
          }       
          if(ev.target.value<=desPen){
            listItem[indexSearch].nuevoValor = ev.target.value
          }
        }else{
          if(ev.target.name === "nuevoValor2"){
            if(!listItem[indexSearch].cantidadCompra || listItem[indexSearch].cantidadCompra=='' || listItem[indexSearch].cantidadCompra==null || listItem[indexSearch].cantidadCompra===0){
              cantComp=ev.target.value
              listItem[indexSearch].cantidadCompra = 0
            }else{
              cantComp=parseInt(listItem[indexSearch].cantidadCompra + ev.target.value)
            }          
            listItem[indexSearch].nuevoValor2 = ev.target.value
          }else{
            if(!listItem[indexSearch].cantidadCompraEjec || listItem[indexSearch].cantidadCompraEjec=='' || listItem[indexSearch].cantidadCompraEjec==null || listItem[indexSearch].cantidadCompraEjec===0){
              cantCompraEjec=ev.target.value
              regPen=listItem[indexSearch].cantidadCompra
              listItem[indexSearch].cantidadCompraEjec = 0
            }else{
              cantCompraEjec=parseInt(listItem[indexSearch].cantidadCompraEjec + ev.target.value)
              regPen=parseInt(listItem[indexSearch].cantidadCompra - listItem[indexSearch].cantidadCompraEjec)
            }          
            if(ev.target.value<=regPen){
              listItem[indexSearch].nuevoValor4 = ev.target.value
            }
          }
        }
      }
      this.setState({lista5: listItem});
    }
  }

  handleChangeDev = (ev, elemento) => {
    if(ev.target.name === "nuevoValor2" || ev.target.name === "nuevoValor3"){
      let listItem=this.state.lista7
      let indexSearch=-1
      if(elemento.idProducto && elemento.idProducto!==null && elemento.idProducto!==''){
        indexSearch = listItem.findIndex(buscaProducto => buscaProducto.idProducto === elemento.idProducto);
      }else{
        indexSearch = listItem.findIndex(buscaProducto => buscaProducto.descrProductoDes === elemento.descrProductoDes);
      }
      if(indexSearch !== -1){
        if(ev.target.name === "nuevoValor2"){
          if(ev.target.value<=listItem[indexSearch].cantidad){
            listItem[indexSearch].nuevoValor2 = ev.target.value
          }
        }else{
          if(parseInt(ev.target.value)<=1){
            listItem[indexSearch].nuevoValor3 = ev.target.value
          }
        }
      }
      this.setState({lista7: listItem});
    }
  }

  handleRemision = async (ev, items, argsDocum)=>{
    let response = await this.props.fecha({
      variables: {}
    });
    const {fechaHoraHoy} = response.data.fecha
    let urlSlcm = 'https://montserratslcm.com/api/logos/'
    let doc = new jsPDF({orientation: 'p', unit: 'mm', format: 'letter'})
    let widthDoc = (doc.internal.pageSize.width)
    let heightDoc = (doc.internal.pageSize.height)
    let heightDisponible=heightDoc
    let logo = '', empresa='', nit='', direccion='', telefono='', empresaWeb='' 
    let cargoUsu='', mailUsu='', telefonoUsu='', firmaUsu=''
    let mail = ''
    let ciudad = ''
    let contacto = ''
    let celular = ''
    let ordenCompraCliente = ''
    
    if(this.props.getParametro.getParametro){
      empresaWeb = this.props.getParametro.getParametro.empresaWeb
    }
    empresa = ''
    nit = ''
    direccion = ''
    telefono = ''
    cargoUsu = ''
    mailUsu = ''
    telefonoUsu = ''
    firmaUsu = ''
    
    doc.setFillColor('#E9E4F0');
    doc.setDrawColor('black');
    doc.rect(12, 30, widthDoc-24, 55)   
    doc.line(12, 40, widthDoc-12, 40)    
    doc.line(12, 45, widthDoc-12, 45)    
    doc.line(12, 50, widthDoc-12, 50)    
    doc.line(12, 55, widthDoc-12, 55)    
    doc.line(12, 60, widthDoc-12, 60)    
    doc.line(12, 65, widthDoc-12, 65)    
    doc.line(12, 70, widthDoc-12, 70) 
    doc.line(12, 80, widthDoc-12, 80) 
    doc.line(37, 30, 37, 80)  
    doc.line(55, 30, 55, 40)
    doc.line(117, 30, 117, 65) 
    doc.line(136, 30, 136, 80) 
    doc.line(162, 30, 162, 40)
    doc.line(162, 70, 162, 80)
    doc.lines([[(widthDoc)-24.4,0],[0,4.6],[0-(widthDoc)+24.4,0]], 12.3,40.3, [1,1], 'F', true)
    doc.lines([[(widthDoc)-24.4,0],[0,4.6],[0-(widthDoc)+24.4,0]], 12.3,65.2, [1,1], 'F', true)
    doc.lines([[(widthDoc)-24.4,0],[0,4.6],[0-(widthDoc)+24.4,0]], 12.3,80.2, [1,1], 'F', true)
    
    doc.setFontSize(8);
    doc.setFontStyle('bold');
    doc.text(`FECHA DE `, 16, 34)
    doc.text(`ELABORACION: `,13, 38)
    doc.text('', 38, 37, 'left')
    doc.text(`FECHA DE ENTREGA: `, 70, 37, {align: 'left',lineHeightFactor: 1,maxWidth:30})
    doc.text('', 119, 37, 'left')
    doc.text(`REMISION: `, 141, 37)
    doc.text('', 163, 37, 'left')
    doc.text(`INFORMACION DEL CLIENTE: `, 85, 44, {align: 'left',lineHeightFactor: 1,maxWidth:58})
    doc.text(`EMPRESA`, 16, 49)
    doc.text(empresa, 38, 49)
    doc.text(`TELEFONO`, 15.5, 54)
    doc.text(telefono, 38, 54)
    doc.text(`CIUDAD`, 18, 59)
    doc.text(ciudad, 38, 59)
    doc.text(`MAIL`, 20, 64)
    doc.text(mail, 38, 64)
    doc.text(`NIT`, 124, 49)
    doc.text(nit, 137, 49)
    doc.text(`DIRECCION`, 118.5, 54)
    doc.text(direccion, 137, 54)
    doc.text(`CONTACTO`, 118.5, 59)
    doc.text(contacto, 137, 59)
    doc.text(`CELULAR`, 119, 64)
    doc.text(celular, 137, 64)
    doc.text(`INFORMACION DE LA REMISION: `, 83, 69, {align: 'left',lineHeightFactor: 1,maxWidth:58})
    doc.text(`Descripción`, 16, 74)
    doc.text(`Orden de compra: `,12.5, 78)
    doc.text(`Código`, 143, 74)
    doc.text(`Orden de compra: `,137.5, 78)
    doc.text('', 163, 76)

    doc.text(`DETALLE DE ORDEN DE COMPRA: `, 83, 84, {align: 'left',lineHeightFactor: 1,maxWidth:58})
    
    
    heightDisponible=heightDoc-80
    let posic = 90
    let tablaRte = []
    let argsUpd = []

    for(let ii=0; ii<10; ii++){
      posic+=5
      heightDisponible=heightDisponible-5

      argsUpd.push(ii+1)
      argsUpd.push('')
      argsUpd.push('')
      argsUpd.push('')
      argsUpd.push('')
      argsUpd.push('')
      tablaRte.push(argsUpd) 
      argsUpd = []
    }
    
    doc.autoTable({
      startY: 85,
      rowPageBreak: 'avoid',  //cambia de página si la ultima fila queda incompleta
      showHead: 'everyPage',
      tableLineColor: "black",
      tableLineWidth: 0.1,
      styles: {
        fontSize: 6,
        lineColor: "black",
        lineWidth: 0.1,
        valign: "top",
      },
      headStyles: {
        fillColor: "#E9E4F0",
        textColor: "black",
        halign: "center",
        valign: "top",
        cellPadding: 1,
        fontStyle: "bold",
        fontSize: 6
      },
      bodyStyles: {
        // fillColor: "#E9E4F0",
        fillColor: "white",
        textColor: "black",
        halign: "center",
        minCellHeight: 1
      },
      columnStyles: {
        0: {cellWidth: 10},
        1: {cellWidth: 105.7},
        2: {cellWidth: 13},
        3: {cellWidth: 13},
        4: {cellWidth: 20},
        5: {cellWidth: 30},
      },

      didParseCell(data) {
        if(data.row.index !== -1 && data.section==='body'){
          data.cell.styles.minCellHeight = 1
          data.cell.styles.fillColor = "white"
          data.cell.styles.fontStyle = "normal"
        }
      },

      alternateRowStyles: {
        // fillColor: "white",
        textColor: "black"
      },
      head: [["ITEM", "DESCRIPCION", "CANTIDAD", "UNIDAD", "RECIBIDO POR", "OBSERVACION"]],
      body: tablaRte,
      margin: {top: 100, left: 12, right: 12, bottom: 25}
    })
    
    posic+=10
    heightDisponible=heightDoc-25-posic
    
    if(heightDisponible<35){
      posic=30
      heightDisponible=heightDoc-25
      doc.addPage()
    }
    doc.setDrawColor('black');
    doc.rect(12, posic, widthDoc-24, 5)
    doc.text(`OBSERVACIONES`, 95, posic+4, 'left')
    doc.rect(12, posic+5, widthDoc-24, 30)
    posic+=35
    heightDisponible=heightDoc-25-posic

    if(heightDisponible<50){
      posic=30
      heightDisponible=heightDoc-25
      doc.addPage()
    }
    doc.rect(12, posic, widthDoc-24, 5)   
    doc.text('INFORMACION DE ACTA DE ENTREGA', 85, posic+4, 'left')

    tablaRte = []
    argsUpd = []

    argsUpd.push('');
    argsUpd.push('');
    tablaRte.push(argsUpd) 
    argsUpd = []
    argsUpd.push('');
    argsUpd.push('');
    tablaRte.push(argsUpd) 
    argsUpd = []
    argsUpd.push('');
    argsUpd.push('');
    tablaRte.push(argsUpd) 
    argsUpd = []  
    argsUpd.push('FIRMA');
    argsUpd.push('FIRMA');
    tablaRte.push(argsUpd) 
    argsUpd = []
    argsUpd.push('Nombre: ');
    argsUpd.push('Nombre: ');
    tablaRte.push(argsUpd) 
    argsUpd = []
    argsUpd.push('Cargo: ');
    argsUpd.push('Cargo: ');
    tablaRte.push(argsUpd) 
    argsUpd = []
    argsUpd.push('email: ');
    argsUpd.push('email: ');
    tablaRte.push(argsUpd) 
    argsUpd = []
    argsUpd.push('Teléfono: ');
    argsUpd.push('Teléfono: ');
    tablaRte.push(argsUpd) 
    argsUpd = []
                
    doc.autoTable({
      startY: posic+5,
      rowPageBreak: 'avoid',  //cambia de página si la ultima fila queda incompleta
      showHead: 'everyPage',
      tableLineColor: "black",
      tableLineWidth: 0.1,
      styles: {
        fontSize: 6,
        lineColor: "black",
        lineWidth: 0.1,
        valign: "top",
      },
      headStyles: {
        fillColor: "#E9E4F0",
        textColor: "black",
        halign: "center",
        valign: "top",
        cellPadding: 1,
        fontStyle: "bold",
        fontSize: 6
      },
      bodyStyles: {
        // fillColor: "#E9E4F0",
        fillColor: "white",
        textColor: "black",
        halign: "left",
        minCellHeight: 1
      },
      columnStyles: {
        0: {cellWidth: 95.9},
        1: {cellWidth: 95.9},
      },

      didParseCell(data) {
        if(data.row.index !== -1 && data.section==='body'){
          data.cell.styles.minCellHeight = 1
          data.cell.styles.fillColor = "white"
          data.cell.styles.fontStyle = "normal"
        }
        if(data.row.index === 0 && data.section==='body'){
          if(data.column.index === 0 || data.column.index === 1){
            data.cell.rowSpan = 3
            data.cell.styles.halign = 'center'
            data.cell.styles.valign = 'center'
          }
        }
        if(data.row.index === 3 && data.section==='body'){
          if(data.column.index === 0 || data.column.index === 1){
            data.cell.styles.halign = 'center'
            data.cell.styles.valign = 'center'
          }
        }
      },

      alternateRowStyles: {
        textColor: "black"
      },
      head: [["CONTRATISTA", "CONTRATANTE"]],
      body: tablaRte,
      margin: {top: 100, left: 12, right: 12, bottom: 25}
    })
    
    const pageCount = doc.internal.getNumberOfPages();
    // For each page, print the page number and the total pages
    for(var i = 1; i <= pageCount; i++) {
          // Go to page i
      doc.setPage(i);

//ENCABEZADO DE PAGINA
      doc.setFontSize(10);
      doc.setTextColor('black');
      doc.setFontType("bold");
      doc.text('', widthDoc/2, 14, 'center')
      doc.text("REMISION: ", widthDoc/2 - 15, 20, 'center')
      doc.setFontSize(6);
      doc.text(" SEÑOR TRANSPORTADOR:", 200, 22, 'right')
      doc.text("FAVOR DEVOLVER ESTE DOCUMENTO DEBIDAMENTE", 200, 25, 'right')
      doc.text(" FIRMADO A LUBRICACION DE CLASE MUNDIAL", 200, 28, 'right')

      let dirSlcm = 'images/logos/LCMSAS.png'
      let imgSource = new Image();
      try{
        imgSource.src = dirSlcm;
        doc.convertStringToImageData(imgSource)
        doc.addImage(imgSource, 'PNG', 12, 12, 55, 17);
      }catch{
        console.log("Logo de LCM no existe")
      }
    //FIN ENCABEZADO DE PAGINA
  
    //PIE DE PAGINA
  
      doc.setFontSize(8);
      doc.setTextColor(255,0,0);
      doc.setFontStyle('Watermark');
      doc.text(empresaWeb, widthDoc/2, heightDoc-15, 'center')
      doc.text("Colombia - Ecuador - Panamá", widthDoc/2, heightDoc-12, 'center')

      doc.text('Pag ' + String(i) + ' de ' + String(pageCount), 12, heightDoc-12, 'left')
      doc.text(fechaHoraHoy.substr(0, 10) + " " + fechaHoraHoy.substr(11, 5), widthDoc-50, heightDoc-12, 'left')
    }
    let nameDoc = 'REMISION.pdf'
    doc.save(nameDoc)
  }

  handleDespachar = async (ev, items, argsDocum)=>{
    console.log(argsDocum)
    const errors = [];
    if(items.length>0){
      const elemento3 = items
      let lista = []
      let cuentaItems=0
      elemento3.forEach((elemento, i) => {
        if(elemento.nuevoValor>0){
          lista[cuentaItems]=elemento
          cuentaItems+=1
        }
      }) 

      if(lista.length>0){
        // if(lista[0].tipoProducto==='Producto' && argsDocum.emailAviso && (!argsDocum.transportadora || !argsDocum.numGuia)){
        //   alert("!! Si define un email para alerta de envío al cliente debe digitar los datos de transportadora y número de guía !!")
        // }else{
          document.body.style.cursor = 'wait'

          console.log(lista)
          
          let consec = lista[0].consecDespacho?parseInt(lista[0].consecDespacho):1
          let nuevoConsec = consec + 1
          // let remision = lista[0].numCoti.replace('COT','REM');
          let remision = lista[0].numCoti
          remision = remision + '_' + consec
          let response = await this.props.fecha({
            variables: {}
          });
          const {fechaHoraHoy} = response.data.fecha

          lista.forEach(async (elemento, i) => {
            let codigo = await this.nextVal('despacho')

            const args = {
              _id: argsDocum._id,
              numDespacho: remision,
              codigo: codigo,
              codAvance: 0,
              descrProductoDes: elemento.descrProducto,
              idProducto: elemento.numProductoCoti?elemento.numProductoCoti:0,
              cantidad: parseInt(elemento.nuevoValor),
              valorDes: 0,
              descrUnidadDes: elemento.descrUnidad,
              porcDctoDes: 0,
              porcIncrementoDes: 0, 
              porcIVADes: 0,
              fechaDespacho: fechaHoraHoy,
              usuarioDespacho: localStorage.getItem('userLogin'),
              despFact: 'D',
              tipoAct: "CrearItemDespacho"
            }
            console.log(args)
            let response = await this.props.editCotizacion({
              variables: args
            });
            const {errors, success} = response.data.editCotizacion;
            if (!success){
              this.setState({errorAdd: errors})
            }else{
              let tipoAc=''
              if(elemento.numProductoCoti && elemento.numProductoCoti>0){
                tipoAc='EditarTotalDespachoID'
              }else{
                tipoAc='EditarTotalDespacho'
              }              
              const argsUpd = {
                numCoti: elemento.numCoti,
                numProductoCoti: elemento.numProductoCoti?elemento.numProductoCoti:0,
                cantidadDespacho: parseInt(elemento.cantidadDespacho) + parseInt(elemento.nuevoValor),
                descrProducto: elemento.descrProducto,
                tipoAct: tipoAc
              }
          console.log(argsUpd)
              const response = await this.props.editCotizacion({
                variables: argsUpd
              });
              const {errors, success} = response.data.editCotizacion;
          
            }
          })
          console.log(errors)

          if(errors.length===0){
            const argsUpd = {
              _id: argsDocum._id,
              consecDespacho: nuevoConsec,
              tipoAct: 'EditarConsecDespacho'
            }
            response = await this.props.editCotizacion({
              variables: argsUpd
            });
            const {errors, success} = response.data.editCotizacion;
          }
          document.body.style.cursor = 'default'
          // if(lista[0].tipoProducto==='Producto'){
            alert("!! Despacho registrado, se generará la remisión !!")
          // }else{
          //   alert("!! Despacho registrado !!")
          // }

          if(errors.length===0){

            // if(lista[0].tipoProducto==='Producto'){
      
              let lista5 = lista
              let response = await this.props.fecha({
                variables: {}
              });
              const {fechaHoraHoy} = response.data.fecha
              let urlSlcm = 'https://montserratslcm.com/api/logos/'
              let doc = new jsPDF({orientation: 'p', unit: 'mm', format: 'letter'})
              let widthDoc = (doc.internal.pageSize.width)
              let heightDoc = (doc.internal.pageSize.height)
              let heightDisponible=heightDoc
              let logo = '', empresa='', nit='', direccion='', telefono='', empresaWeb='' 
              let cargoUsu='', mailUsu='', telefonoUsu='', firmaUsu='', nombreUsu=''
              let mail = lista[0].mailContacto?lista[0].mailContacto:''
              let ciudad = lista[0].ciudadContacto?lista[0].ciudadContacto:''
              let contacto = lista[0].nombreContacto?lista[0].nombreContacto:''
              let celular = lista[0].telContacto?lista[0].telContacto:''
              let ordenCompraCliente = argsDocum.ordenCompraCliente?argsDocum.ordenCompraCliente:''
      
              if(this.props.getParametro.getParametro){
                empresaWeb = this.props.getParametro.getParametro.empresaWeb
              }
              if(this.props.allEmpresaRtes.allEmpresaRtes){
                let argsBuscarEmp = {tipoqry: `[{$match: {'descrEmpresa': '${lista[0].descrEmpresa}'}}]`}
                console.log(argsBuscarEmp)
                let {data} = await this.props.allEmpresaRtes.refetch(argsBuscarEmp)
                empresa = data.allEmpresaRtes[0].descrEmpresa
                nit = data.allEmpresaRtes[0].nit?data.allEmpresaRtes[0].nit:''
                direccion = argsDocum.dirEntrega?argsDocum.dirEntrega:data.allEmpresaRtes[0].direccion?data.allEmpresaRtes[0].direccion:''
                telefono = data.allEmpresaRtes[0].telefono?data.allEmpresaRtes[0].telefono:''
              }
              if(this.props.allUsuariosRtes.allUsuariosRtes){
                let argsBuscarUsu = {tipoqry: `[{$match: {'email': '${localStorage.getItem('userLogin')}'}}]`}
                let {data} = await this.props.allUsuariosRtes.refetch(argsBuscarUsu)
                nombreUsu = data.allUsuariosRtes[0].nombreUsuario?data.allUsuariosRtes[0].nombreUsuario:''
                cargoUsu = data.allUsuariosRtes[0].cargo?data.allUsuariosRtes[0].cargo:''
                mailUsu = data.allUsuariosRtes[0].email?data.allUsuariosRtes[0].email:''
                telefonoUsu = data.allUsuariosRtes[0].telefono?data.allUsuariosRtes[0].telefono:''
                firmaUsu = data.allUsuariosRtes[0].archivoFirma?data.allUsuariosRtes[0].archivoFirma:''
              }
              let dirEmpresa = 'images/logos/' + logo
              let archivoFirma=''
              if (firmaUsu!==''){
                archivoFirma=urlSlcm + firmaUsu
              }
      
                  doc.setFillColor('#E9E4F0');
                  doc.setDrawColor('black');
                  // doc.lines([[(widthDoc)-20,0],[0,5],[0-(widthDoc)+20,0]], 12,35, [1,1], 'S', true)  
                  doc.rect(12, 30, widthDoc-24, 55)   
                  doc.line(12, 40, widthDoc-12, 40)    
                  doc.line(12, 45, widthDoc-12, 45)    
                  doc.line(12, 50, widthDoc-12, 50)    
                  doc.line(12, 55, widthDoc-12, 55)    
                  doc.line(12, 60, widthDoc-12, 60)    
                  doc.line(12, 65, widthDoc-12, 65)    
                  doc.line(12, 70, widthDoc-12, 70) 
                  doc.line(12, 80, widthDoc-12, 80) 
                  doc.line(37, 30, 37, 80)  
                  doc.line(55, 30, 55, 40)
                  doc.line(117, 30, 117, 65) 
                  doc.line(136, 30, 136, 80) 
                  doc.line(162, 30, 162, 40)
                  doc.line(162, 70, 162, 80)
                  doc.lines([[(widthDoc)-24.4,0],[0,4.6],[0-(widthDoc)+24.4,0]], 12.3,40.3, [1,1], 'F', true)
                  doc.lines([[(widthDoc)-24.4,0],[0,4.6],[0-(widthDoc)+24.4,0]], 12.3,65.2, [1,1], 'F', true)
                  doc.lines([[(widthDoc)-24.4,0],[0,4.6],[0-(widthDoc)+24.4,0]], 12.3,80.2, [1,1], 'F', true)
      
                  doc.setFontSize(8);
                  doc.setFontStyle('bold');
                  doc.text(`FECHA DE `, 16, 34)
                  // doc.text(`FECHA DE ELABORACION: `, 13, 34, {align: 'left',lineHeightFactor: 1,maxWidth:22})
                  doc.text(`ELABORACION: `,13, 38)
                  doc.text(fechaHoraHoy.substr(0, 10), 38, 37, 'left')
                  doc.text(`FECHA DE ENTREGA: `, 70, 37, {align: 'left',lineHeightFactor: 1,maxWidth:30})
                  doc.text(fechaHoraHoy.substr(0, 10), 119, 37, 'left')
                  doc.text(`REMISION: `, 141, 37)
                  doc.text(remision, 163, 37, 'left')
                  doc.text(`INFORMACION DEL CLIENTE: `, 85, 44, {align: 'left',lineHeightFactor: 1,maxWidth:58})
                  doc.text(`EMPRESA`, 16, 49)
                  doc.text(empresa, 38, 49)
                  doc.text(`TELEFONO`, 15.5, 54)
                  doc.text(telefono, 38, 54)
                  doc.text(`CIUDAD`, 18, 59)
                  doc.text(ciudad, 38, 59)
                  doc.text(`MAIL`, 20, 64)
                  doc.text(mail, 38, 64)
                  doc.text(`NIT`, 124, 49)
                  doc.text(nit, 137, 49)
                  doc.text(`DIRECCION`, 118.5, 54)
                  doc.text(direccion, 137, 54)
                  doc.text(`CONTACTO`, 118.5, 59)
                  doc.text(contacto, 137, 59)
                  doc.text(`CELULAR`, 119, 64)
                  doc.text(celular, 137, 64)
                  doc.text(`INFORMACION DE LA REMISION: `, 83, 69, {align: 'left',lineHeightFactor: 1,maxWidth:58})
                  doc.text(`Descripción`, 16, 74)
                  doc.text(`Orden de compra: `,12.5, 78)
                  doc.text(`Código`, 143, 74)
                  doc.text(`Orden de compra: `,137.5, 78)
                  doc.text(ordenCompraCliente, 163, 76)
      
                  doc.text(`DETALLE DE ORDEN DE COMPRA: `, 83, 84, {align: 'left',lineHeightFactor: 1,maxWidth:58})
      
      
                  heightDisponible=heightDoc-80
                  let posic = 90
                  let lineasProd = 0
                  let lineasUni = 0
                  let tablaRte = []
                  let argsUpd = []
                  let numLineas = 0
      
                  lista5.forEach((elemento1, iii) => {
                    numLineas = lista5.length
      
                    if(elemento1.descrProducto!=='Transporte' && elemento1.descrProducto!=='Transporte producto' && elemento1.descrProducto!=='Alojamiento, alimentación y transporte'){
                      let parrafoProd = elemento1.descrProducto.split("\n")
                      let heightLineaItem=0
                      let parrafoUni = elemento1.descrUnidad.split("\n")
              
                      parrafoProd.forEach((textoProd, ii) => {   
                        lineasProd = doc.splitTextToSize(textoProd, 148)
                        lineasUni = doc.splitTextToSize(parrafoUni, 14)
                        if(textoProd){
                          if(lineasProd.length===1){
                            if(lineasUni.length===1){
                              posic+=5
                              heightLineaItem=5
                            }else{
                              posic+=5*lineasUni.length
                              heightLineaItem=(5*lineasUni.length)
                            }            
                          }else{
                            posic+=5*lineasProd.length
                            heightLineaItem=(5*lineasProd.length)
                          }
                          if(heightLineaItem>heightDisponible){
                            posic=35
                            heightDisponible=heightDoc-25
                          }
                          if(lineasProd.length===1){
                            if(lineasUni.length===1){
                              heightDisponible=heightDisponible-5
                            }else{
                              heightDisponible=heightDisponible-(5*lineasUni.length)
                            }            
                          }else{
                            heightDisponible=heightDisponible-(5*lineasProd.length)
                          }
                        }
                      })
      
                      argsUpd.push(iii+1)
                      argsUpd.push(elemento1.descrProducto)
                      argsUpd.push(elemento1.nuevoValor)
                      argsUpd.push(elemento1.descrUnidad)
                      argsUpd.push('')
                      argsUpd.push('')
                      tablaRte.push(argsUpd) 
                      argsUpd = []
                    }
                  })
                  
      
                  let indice = 0
                  let esComp = false
                  doc.autoTable({
                    startY: 85,
                    rowPageBreak: 'avoid',  //cambia de página si la ultima fila queda incompleta
                    showHead: 'everyPage',
                    tableLineColor: "black",
                    tableLineWidth: 0.1,
                    styles: {
                      fontSize: 6,
                      lineColor: "black",
                      lineWidth: 0.1,
                      valign: "top",
                    },
                    headStyles: {
                      fillColor: "#E9E4F0",
                      textColor: "black",
                      halign: "center",
                      valign: "top",
                      cellPadding: 1,
                      fontStyle: "bold",
                      fontSize: 6
                    },
                    bodyStyles: {
                      // fillColor: "#E9E4F0",
                      fillColor: "white",
                      textColor: "black",
                      halign: "center",
                      minCellHeight: 1
                    },
                    columnStyles: {
                      0: {cellWidth: 10},
                      1: {cellWidth: 105.7},
                      2: {cellWidth: 13},
                      3: {cellWidth: 13},
                      4: {cellWidth: 20},
                      5: {cellWidth: 28},
                    },
      
                    didParseCell(data) {
                      if(data.row.index !== -1 && data.section==='body'){
                        data.cell.styles.minCellHeight = 1
                        data.cell.styles.fillColor = "white"
                        data.cell.styles.fontStyle = "normal"
                      }
                    },
      
                    didDrawCell: (data) => {
                      //imagenes en autoTable
                      //https://github.com/simonbengtsson/jsPDF-AutoTable/issues/93
        if(data.row.index===-1){
        console.log("ojoooo")
        }
                    },
                    alternateRowStyles: {
                      // fillColor: "white",
                      textColor: "black"
                    },
                    head: [["ITEM", "DESCRIPCION", "CANTIDAD", "UNIDAD", "RECIBIDO POR", "OBSERVACION"]],
                    body: tablaRte,
                    margin: {top: 100, left: 12, right: 12, bottom: 25}
                  })
      
                  // doc.setFillColor('#E9E4F0');
                  // doc.lines([[(widthDoc/2)-20,0],[0,5],[0-(widthDoc/2)+20,0]], 12,150, [1,1], 'F', true)
                  // doc.lines([[(widthDoc/2)-20,0],[0,5],[0-(widthDoc/2)+20,0]], (widthDoc/2),150, [1,1], 'F', true)
                  // doc.setFillColor('#bdc3c7');
      
                  posic+=10
                  heightDisponible=heightDoc-25-posic
                  
                  if(heightDisponible<35){
                    posic=30
                    heightDisponible=heightDoc-25
                    doc.addPage()
                  }
                  doc.setDrawColor('black');
                  doc.rect(12, posic, widthDoc-24, 5)
                  doc.text(`OBSERVACIONES`, 95, posic+4, 'left')
                  doc.rect(12, posic+5, widthDoc-24, 30)
                  posic+=35
                  heightDisponible=heightDoc-25-posic
      
                  if(heightDisponible<50){
                    posic=30
                    heightDisponible=heightDoc-25
                    doc.addPage()
                  }
                  doc.rect(12, posic, widthDoc-24, 5)   
                  doc.text(`INFORMACION DE ACTA DE ENTREGA`, 85, posic+4, 'left')
      
                  tablaRte = []
                  argsUpd = []
      
                  argsUpd.push('');
                  argsUpd.push('');
                  tablaRte.push(argsUpd) 
                  argsUpd = []
                  argsUpd.push('');
                  argsUpd.push('');
                  tablaRte.push(argsUpd) 
                  argsUpd = []
                  argsUpd.push('');
                  argsUpd.push('');
                  tablaRte.push(argsUpd) 
                  argsUpd = []  
                  argsUpd.push('FIRMA');
                  argsUpd.push('FIRMA');
                  tablaRte.push(argsUpd) 
                  argsUpd = []
                  argsUpd.push('Nombre: ' + nombreUsu);
                  argsUpd.push('Nombre: ');
                  tablaRte.push(argsUpd) 
                  argsUpd = []
                  argsUpd.push('Cargo: ' + cargoUsu);
                  argsUpd.push('Cargo: ');
                  tablaRte.push(argsUpd) 
                  argsUpd = []
                  argsUpd.push('email: ' + mailUsu);
                  argsUpd.push('email: ');
                  tablaRte.push(argsUpd) 
                  argsUpd = []
                  argsUpd.push('Teléfono: ' + telefonoUsu);
                  argsUpd.push('Teléfono: ');
                  tablaRte.push(argsUpd) 
                  argsUpd = []
      
                  
                  doc.autoTable({
                    startY: posic+5,
                    rowPageBreak: 'avoid',  //cambia de página si la ultima fila queda incompleta
                    showHead: 'everyPage',
                    tableLineColor: "black",
                    tableLineWidth: 0.1,
                    styles: {
                      fontSize: 6,
                      lineColor: "black",
                      lineWidth: 0.1,
                      valign: "top",
                    },
                    headStyles: {
                      fillColor: "#E9E4F0",
                      textColor: "black",
                      halign: "center",
                      valign: "top",
                      cellPadding: 1,
                      fontStyle: "bold",
                      fontSize: 6
                    },
                    bodyStyles: {
                      // fillColor: "#E9E4F0",
                      fillColor: "white",
                      textColor: "black",
                      halign: "left",
                      minCellHeight: 1
                    },
                    columnStyles: {
                      0: {cellWidth: 95.6},
                      1: {cellWidth: 95.6},
                    },
      
                    didParseCell(data) {
                      if(data.row.index !== -1 && data.section==='body'){
                        data.cell.styles.minCellHeight = 1
                        data.cell.styles.fillColor = "white"
                        data.cell.styles.fontStyle = "normal"
                      }
                      if(data.row.index === 0 && data.section==='body'){
                        if(data.column.index === 0 || data.column.index === 1){
                          data.cell.rowSpan = 3
                          data.cell.styles.halign = 'center'
                          data.cell.styles.valign = 'center'
                        }
                      }
                      if(data.row.index === 3 && data.section==='body'){
                        if(data.column.index === 0 || data.column.index === 1){
                          data.cell.styles.halign = 'center'
                          data.cell.styles.valign = 'center'
                        }
                      }
                    },
      
                    didDrawCell: (data) => {
                      //imagenes en autoTable
                      //https://github.com/simonbengtsson/jsPDF-AutoTable/issues/93
                    if(data.row.index===-1){
                    console.log("ojoooo")
                    }
    
                    if(data.row.index === 0 && data.section==='body' && data.column.index === 0){
                      if(archivoFirma!==''){
                        let imgSourceCB = new Image();
                        imgSourceCB.src = archivoFirma;
                        doc.convertStringToImageData(imgSourceCB)
                        doc.addImage(imgSourceCB, 'PNG', data.cell.x + 26.5, data.cell.y - 2.5, 40, 20);
                      }
                    }
    
    
                    },
                    alternateRowStyles: {
                      textColor: "black"
                    },
                    head: [["CONTRATISTA", "CONTRATANTE"]],
                    body: tablaRte,
                    margin: {top: 100, left: 12, right: 12, bottom: 25}
                  })
      
      
      
      
                const pageCount = doc.internal.getNumberOfPages();
                // For each page, print the page number and the total pages
                for(var i = 1; i <= pageCount; i++) {
                      // Go to page i
                    doc.setPage(i);
      
        //ENCABEZADO DE PAGINA
                    doc.setFontSize(10);
                    doc.setTextColor('black');
                    doc.setFontType("bold");
                    doc.text(lista[0].descrEmpresa, widthDoc/2, 14, 'center')
                    doc.text("REMISION: " + remision, widthDoc/2, 20, 'center')
                    doc.setFontSize(6);
                    doc.text(" SEÑOR TRANSPORTADOR:", 200, 22, 'right')
                    doc.text("FAVOR DEVOLVER ESTE DOCUMENTO DEBIDAMENTE", 200, 25, 'right')
                    doc.text(" FIRMADO A LUBRICACION DE CLASE MUNDIAL", 200, 28, 'right')
      
                    let dirSlcm = 'images/logos/LCMSAS.png'
                    let logo = ""
                    let imgSource = new Image();
                    try{
                      imgSource.src = dirSlcm;
                      doc.convertStringToImageData(imgSource)
                      doc.addImage(imgSource, 'PNG', 12, 12, 55, 17);
                    }catch{
                      console.log("Logo de LCM no existe")
                    }
        //FIN ENCABEZADO DE PAGINA
      
        //PIE DE PAGINA
      
                    doc.setFontSize(8);
                    doc.setTextColor(255,0,0);
                    doc.setFontStyle('Watermark');
                    doc.text(empresaWeb, widthDoc/2, heightDoc-15, 'center')
                    doc.text("Colombia - Ecuador - Panamá", widthDoc/2, heightDoc-12, 'center')
      
                    doc.text('Pag ' + String(i) + ' de ' + String(pageCount), 12, heightDoc-12, 'left')
                    doc.text(fechaHoraHoy.substr(0, 10) + " " + fechaHoraHoy.substr(11, 5), widthDoc-50, heightDoc-12, 'left')
                    // doc.text('Pag ' + String(i) + ' de ' + String(pageCount),210-20,297-30,null,null,"left");
                }
              
                if(argsDocum.emailAviso){
                  let mailUsu = argsDocum.emailAviso
                  // let mailUsu = 'amartinezgomez@hotmail.com'
                  let nomDestino = lista[0].descrEmpresa
                  let mensajeMail = "SU ENVÍO ESTÁ EN CAMINO" + "\n" + "\n"
                  mensajeMail+="Su envío de " + argsDocum.transportadora + " con número de guía " + argsDocum.numGuia + " de LUBRICACION DE CLASE MUNDIAL SAS está en camino.  Se requerira una firma al momento de la entrega." + "\n" + "\n"
                  mensajeMail+="La fecha de entrega actual estimadas es  " + argsDocum.fechaEntrega + " antes del final del día." + "\n"

                  let cuentaDestino = mailUsu
                  let parametroMail1 = '', parametroMail2 = '', parametroMail3 = ''
                  if(this.props.getParametro.getParametro){
                    parametroMail1 = this.props.getParametro.getParametro.parametroMail1
                    parametroMail2 = this.props.getParametro.getParametro.parametroMail2
                    parametroMail3 = this.props.getParametro.getParametro.parametroMail3
                  }
                  emailjs.send(parametroMail1,parametroMail2,{
                    to_name: nomDestino,
                    message: mensajeMail,
                    destino: cuentaDestino,
                  }, parametroMail3);
                }
              let nameDoc = `REMISION_${remision}_${lista[0].descrEmpresa}.pdf`
              doc.save(nameDoc)
            // }
            let argsBuscar=""
            argsBuscar += `numCoti: '${this.props.idLista.numCoti}'`
            let argsBuscarIt = {}
            argsBuscarIt = {tipoqry: `[${this.state.argsQuery1}, {$match: {${argsBuscar}}}]`}

            let {data} = await this.props.allCotizacionRtes11.refetch(argsBuscarIt)
            let registros = await data.allCotizacionRtes
            let listaNueva = []
            const elemento3 = registros
            elemento3.forEach((elemento, i) => {
              listaNueva.push({numCoti: elemento.numCoti, 
                consecDespacho: elemento.consecDespacho, 
                consecAvance: elemento.consecAvance, 
                descrEmpresa: elemento.descrEmpresa, 
                ordenCompraCliente: elemento.ordenCompraCliente?elemento.ordenCompraCliente:'',
                mail: elemento.mail, 
                ciudad: elemento.ciudad, 
                contacto: elemento.contacto, 
                nombreContacto: elemento.nombreContacto,
                ciudadContacto: elemento.ciudadContacto,
                cargoContacto: elemento.cargoContacto,
                mailContacto: elemento.mailContacto,
                telContacto: elemento.telContacto,
                celular: elemento.celular?elemento.celular:'', 
                descrProducto: elemento.descrProducto,
                numProductoCoti: elemento.numProductoCoti?elemento.numProductoCoti:0,
                cantidadCoti: elemento.cantidadCoti,
                descrUnidad: elemento.descrUnidad,
                cantidadDespacho: elemento.cantidadDespacho, 
                cantidadCompra: elemento.cantidadCompra, cantidadCompraEjec: elemento.cantidadCompraEjec, 
                nuevoValor: 0, nuevoValor2: 0, nuevoValor4: 0, _id: i
              });
            }) 
            this.setState({lista5: listaNueva})
            this.props.allCotizacionRtes11.refetch()

          }
        // }  
   
      }else{
        alert("!! No existen productos a despachar !!")
      }
    }else{
      alert("!! No existen productos a despachar !!")
    }
  }

  handleComprar = async (ev, items, argsDocum)=>{
    console.log(argsDocum)
    const errors = [];
    if(items.length>0){
      const elemento3 = items
      let lista = []
      let cuentaItems=0
      elemento3.forEach((elemento, i) => {
        if(elemento.nuevoValor2>0){
          lista[cuentaItems]=elemento
          cuentaItems+=1
        }
      }) 

      if(lista.length>0){
        document.body.style.cursor = 'wait'

        console.log(lista)
        
        let consec = lista[0].consecAvance?parseInt(lista[0].consecAvance):1
        let nuevoConsec = consec + 1
        let totalFactura = 0
        let valorItem = 0
        let response = await this.props.fecha({
          variables: {}
        });
        const {fechaHoraHoy} = response.data.fecha
        let allUsuarios = await this.props.allUsuariosRtes.allUsuariosRtes
        let indexUsu = allUsuarios.findIndex( usuarios => usuarios.email===localStorage.getItem('userLogin') )
        let nombreUsu = allUsuarios[indexUsu].nombreUsuario

        lista.forEach(async (elemento, i) => {
          const args = {
            descrProducto: elemento.descrProducto,
            cantidad: parseInt(elemento.nuevoValor2),
            activo: 'S',
            fechaCreate: fechaHoraHoy,
            usuarioCreate: nombreUsu,
          }
          let response = await this.props.createSolicCompra({
            variables: args
          });
          const {errors, success} = response.data.createSolicCompra;
          if (!success){
            this.setState({errorAdd: errors})
          }else{
            let tipoAc=''
            if(elemento.numProductoCoti && elemento.numProductoCoti>0){
              tipoAc = 'EditarCantCompraID'
            }else{
              tipoAc = 'EditarCantCompra'
            }
            const argsUpd = {
              numCoti: elemento.numCoti,
              cantidadCompra: parseInt(elemento.cantidadCompra) + parseInt(elemento.nuevoValor2),
              descrProducto: elemento.descrProducto,
              numProductoCoti: elemento.numProductoCoti?elemento.numProductoCoti:0,
              fechaSolicCompra: fechaHoraHoy,
              tipoAct: tipoAc
            }
            const response = await this.props.editCotizacion({
              variables: argsUpd
            });
            const {errors, success} = response.data.editCotizacion;
          }
        })

        document.body.style.cursor = 'default'
        alert("!! Solicitud de compra registrada !!")

        let argsBuscar=""
        argsBuscar += `numCoti: '${this.props.idLista.numCoti}'`
        let argsBuscarIt = {}
        argsBuscarIt = {tipoqry: `[${this.state.argsQuery1}, {$match: {${argsBuscar}}}]`}
        console.log(argsBuscarIt)
        let {data} = await this.props.allCotizacionRtes11.refetch(argsBuscarIt)
        let registros = await data.allCotizacionRtes
        this.setState({lista5: registros})
        this.props.allCotizacionRtes11.refetch()
      
      }else{
        alert("!! No existen productos para comprar !!")
      }
    }else{
      alert("!! No existen productos para comprar !!")
    }
  }

  handleComprarEjec = async (ev, items, argsDocum)=>{
    const errors = [];
    if(items.length>0){
      const elemento4 = items
      let lista = []
      let cuentaItems=0
      elemento4.forEach((elemento, i) => {
        if(elemento.nuevoValor4>0){
          lista[cuentaItems]=elemento
          cuentaItems+=1
        }
      }) 

      if(lista.length>0){
        document.body.style.cursor = 'wait'
        
        let response = await this.props.fecha({
          variables: {}
        });
        const {fechaHoraHoy} = response.data.fecha

        lista.forEach(async (elemento, i) => {
          let tipoAc=''
          if(elemento.numProductoCoti && elemento.numProductoCoti>0){
            tipoAc = 'EditarCantCompraEjecID'
          }else{
            tipoAc = 'EditarCantCompraEjec'
          }
          const argsUpd = {
            numCoti: elemento.numCoti,
            cantidadCompraEjec: parseInt(elemento.cantidadCompraEjec) + parseInt(elemento.nuevoValor4),
            descrProducto: elemento.descrProducto,
            numProductoCoti: elemento.numProductoCoti?elemento.numProductoCoti:0,
            fechaEjecCompra: fechaHoraHoy,
            tipoAct: tipoAc
          }
          const response = await this.props.editCotizacion({
            variables: argsUpd
          });
          const {errors, success} = response.data.editCotizacion;
        })

        document.body.style.cursor = 'default'
        alert("!! Compra registrada !!")

        let argsBuscar=""
        argsBuscar += `numCoti: '${this.props.idLista.numCoti}'`
        let argsBuscarIt = {}
        argsBuscarIt = {tipoqry: `[${this.state.argsQuery1}, {$match: {${argsBuscar}}}]`}
        console.log(argsBuscarIt)
        let {data} = await this.props.allCotizacionRtes11.refetch(argsBuscarIt)
        let registros = await data.allCotizacionRtes
        this.setState({lista5: registros})
        this.props.allCotizacionRtes11.refetch()
      
      }else{
        alert("!! No existen compras para registrar !!")
      }
    }else{
      alert("!! No existen compras para registrar !!")
    }
  }


  handleDevolver = async (ev, items, argsDocum)=>{
    console.log(argsDocum)
    const errors = [];
    if(items.length>0){
      const elemento3 = items
      let lista = []
      let cuentaItems=0
      elemento3.forEach((elemento, i) => {
        if(elemento.nuevoValor2>0){
          lista[cuentaItems]=elemento
          cuentaItems+=1
        }
      }) 

      if(lista.length>0){
        document.body.style.cursor = 'wait'

        console.log(lista)
        
        let nuevaCantidadDespacho = 0
        let response = await this.props.fecha({
          variables: {}
        });
        const {fechaHoraHoy} = response.data.fecha

        lista.forEach(async (elemento, i) => {
          nuevaCantidadDespacho=elemento.cantidad - elemento.nuevoValor2
          let tipoAc=''
          if(elemento.idProducto && elemento.idProducto>0){
            tipoAc = 'EditarItemDespachoID'
          }else{
            tipoAc = 'EditarItemDespacho'
          }
          const args = {
            _id: argsDocum._id,
            numDespacho: elemento.numDespacho,
            descrProductoDes: elemento.descrProductoDes,
            idProducto: elemento.idProducto?elemento.idProducto:0,
            cantidad: parseInt(nuevaCantidadDespacho),
            cantidadDev: parseInt(elemento.nuevoValor2),
            tipoAct: tipoAc
          }
          console.log(args)
          let response = await this.props.editCotizacion({
            variables: args
          });
          const {errors, success} = response.data.editCotizacion;
          if (!success){
            this.setState({errorAdd: errors})
          }
        })


        document.body.style.cursor = 'default'
        alert("!! Devolución registrada !!")

        let argsBuscar=""
        let registros = [], registros2 = []
        argsBuscar += `numCoti: '${this.props.idLista.numCoti}'`
        let argsBuscarIt = {}
        argsBuscarIt = {tipoqry: `[${this.state.argsQuery1}, {$match: {${argsBuscar}}}]`}
        let {data} = await this.props.allCotizacionRtes11.refetch(argsBuscarIt)
        registros = await data.allCotizacionRtes
        
      
        if(2>1){
          argsBuscarIt = {tipoqry: `[${this.state.argsQuery2}, {$match: {${argsBuscar}}}]`}
          let {data} = await this.props.allCotizacionRtes11.refetch(argsBuscarIt)
          registros2 = await data.allCotizacionRtes
        }
        this.props.allCotizacionRtes11.refetch()

        this.setState({lista5: registros, lista7: registros2})

      }else{
        alert("!! No existen productos a devolver !!")
      }
    }else{
      alert("!! No existen productos a devolver !!")
    }
  }

  handleImprimir = async (ev, items, argsDocum)=>{
    const errors = [];
    // if(argsDocum.tipo==="Producto"){
      if(items.length>0){
        const elemento3 = items
        let lista = []
        elemento3.forEach((elemento, i) => {
          if(parseInt(elemento.nuevoValor3)===1){
            lista = items.filter(despacho => despacho.numDespacho===elemento.numDespacho)
          }
        }) 

        if(lista.length>0){
          document.body.style.cursor = 'wait'
          
          let lista5 = lista
          let remision = lista[0].numDespacho

          let response = await this.props.fecha({
            variables: {}
          });
          const {fechaHoraHoy} = response.data.fecha
          let urlSlcm = 'https://montserratslcm.com/api/logos/'
          let doc = new jsPDF({orientation: 'p', unit: 'mm', format: 'letter'})
          let widthDoc = (doc.internal.pageSize.width)
          let heightDoc = (doc.internal.pageSize.height)
          let heightDisponible=heightDoc
          let logo = '', empresa='', nit='', direccion='', telefono='', empresaWeb='' 
          let cargoUsu='', mailUsu='', telefonoUsu='', firmaUsu='', nombreUsu=''
          let mail = lista[0].mailContacto?lista[0].mailContacto:''
          let ciudad = lista[0].ciudadContacto?lista[0].ciudadContacto:''
          let contacto = lista[0].nombreContacto?lista[0].nombreContacto:''
          let celular = lista[0].telContacto?lista[0].telContacto:''
          let ordenCompraCliente = lista[0].ordenCompraCliente?lista[0].ordenCompraCliente:''
  
          if(this.props.getParametro.getParametro){
            empresaWeb = this.props.getParametro.getParametro.empresaWeb
          }
          if(this.props.allEmpresaRtes.allEmpresaRtes){
            let argsBuscarEmp = {tipoqry: `[{$match: {'descrEmpresa': '${lista[0].descrEmpresa}'}}]`}
            let {data} = await this.props.allEmpresaRtes.refetch(argsBuscarEmp)
            empresa = data.allEmpresaRtes[0].descrEmpresa
            nit = data.allEmpresaRtes[0].nit?data.allEmpresaRtes[0].nit:''
            direccion = argsDocum.dirEntrega?argsDocum.dirEntrega:data.allEmpresaRtes[0].direccion?data.allEmpresaRtes[0].direccion.substr(0, 56):''
            telefono = data.allEmpresaRtes[0].telefono?data.allEmpresaRtes[0].telefono:''
          }
          if(this.props.allUsuariosRtes.allUsuariosRtes){
            let argsBuscarUsu = {tipoqry: `[{$match: {'email': '${localStorage.getItem('userLogin')}'}}]`}
            let {data} = await this.props.allUsuariosRtes.refetch(argsBuscarUsu)
            nombreUsu = data.allUsuariosRtes[0].nombreUsuario?data.allUsuariosRtes[0].nombreUsuario:''
            cargoUsu = data.allUsuariosRtes[0].cargo?data.allUsuariosRtes[0].cargo:''
            mailUsu = data.allUsuariosRtes[0].email?data.allUsuariosRtes[0].email:''
            telefonoUsu = data.allUsuariosRtes[0].telefono?data.allUsuariosRtes[0].telefono:''
            firmaUsu = data.allUsuariosRtes[0].archivoFirma?data.allUsuariosRtes[0].archivoFirma:''
          }
          let dirEmpresa = 'images/logos/' + logo
          let archivoFirma=''
          if (firmaUsu!==''){
            archivoFirma=urlSlcm + firmaUsu
          }
  
              doc.setFillColor('#E9E4F0');
              doc.setDrawColor('black');
              doc.rect(12, 30, widthDoc-24, 55)   
              doc.line(12, 40, widthDoc-12, 40)    
              doc.line(12, 45, widthDoc-12, 45)    
              doc.line(12, 50, widthDoc-12, 50)    
              doc.line(12, 55, widthDoc-12, 55)    
              doc.line(12, 60, widthDoc-12, 60)    
              doc.line(12, 65, widthDoc-12, 65)    
              doc.line(12, 70, widthDoc-12, 70) 
              doc.line(12, 80, widthDoc-12, 80) 
              doc.line(37, 30, 37, 80)  
              doc.line(55, 30, 55, 40)
              doc.line(105, 30, 105, 65) 
              doc.line(124, 30, 124, 80) 
              doc.line(154, 30, 154, 40)
              doc.line(154, 70, 154, 80)
              doc.lines([[(widthDoc)-24.4,0],[0,4.6],[0-(widthDoc)+24.4,0]], 12.3,40.3, [1,1], 'F', true)
              doc.lines([[(widthDoc)-24.4,0],[0,4.6],[0-(widthDoc)+24.4,0]], 12.3,65.2, [1,1], 'F', true)
              doc.lines([[(widthDoc)-24.4,0],[0,4.6],[0-(widthDoc)+24.4,0]], 12.3,80.2, [1,1], 'F', true)
  
              doc.setFontSize(8);
              doc.setFontStyle('bold');
              doc.text(`FECHA DE `, 16, 34)
              doc.text(`ELABORACION: `,13, 38)
              doc.text(fechaHoraHoy.substr(0, 10), 38, 37, 'left')
              doc.text(`FECHA DE ENTREGA: `, 70, 37, {align: 'left',lineHeightFactor: 1,maxWidth:30})
              doc.text(fechaHoraHoy.substr(0, 10), 106, 37, 'left')
              doc.text(`REMISION: `, 135, 37)
              doc.text(remision, 155, 37, 'left')
              doc.text(`INFORMACION DEL CLIENTE: `, 85, 44, {align: 'left',lineHeightFactor: 1,maxWidth:58})
              doc.text(`EMPRESA`, 16, 49)
              doc.text(empresa, 38, 49)
              doc.text(`TELEFONO`, 15.5, 54)
              doc.text(telefono, 38, 54)
              doc.text(`CIUDAD`, 18, 59)
              doc.text(ciudad, 38, 59)
              doc.text(`MAIL`, 20, 64)
              doc.text(mail, 38, 64)
              doc.text(`NIT`, 112, 49)
              doc.text(nit, 125, 49)
              doc.text(`DIRECCION`, 106.5, 54)
              doc.text(direccion, 125, 54)
              doc.text(`CONTACTO`, 106.5, 59)
              doc.text(contacto, 125, 59)
              doc.text(`CELULAR`, 107, 64)
              doc.text(celular, 125, 64)
              doc.text(`INFORMACION DE LA REMISION: `, 83, 69, {align: 'left',lineHeightFactor: 1,maxWidth:58})
              doc.text(`Descripción`, 16, 74)
              doc.text(`Orden de compra: `,12.5, 78)
              doc.text(`Código`, 131, 74)
              doc.text(`Orden de compra: `,125.5, 78)
              doc.text(ordenCompraCliente, 156, 76)
  
              doc.text(`DETALLE DE ORDEN DE COMPRA: `, 83, 84, {align: 'left',lineHeightFactor: 1,maxWidth:58})
  
  
              heightDisponible=heightDoc-80
              let posic = 90
              let lineasProd = 0
              let lineasUni = 0
              let tablaRte = []
              let argsUpd = []
              let numLineas = 0
  
              lista5.forEach((elemento1, iii) => {
                numLineas = lista5.length
  
                if(elemento1.descrProductoDes!=='Transporte' && elemento1.descrProductoDes!=='Transporte producto' && elemento1.descrProductoDes!=='Alojamiento, alimentación y transporte'){
                  let parrafoProd = elemento1.descrProductoDes.split("\n")
                  console.log(parrafoProd)
                  let heightLineaItem=0
                  let parrafoUni = elemento1.descrUnidadDes.split("\n")
          
                  parrafoProd.forEach((textoProd, ii) => {   
                    lineasProd = doc.splitTextToSize(textoProd, 148)
                    lineasUni = doc.splitTextToSize(parrafoUni, 14)
                    console.log(textoProd, lineasProd)
                    console.log(parrafoUni, lineasUni)
                    if(textoProd){
                      if(lineasProd.length===1){
                        if(lineasUni.length===1){
                          posic+=5
                          heightLineaItem=5
                        }else{
                          posic+=5*lineasUni.length
                          heightLineaItem=(5*lineasUni.length)
                        }            
                      }else{
                        posic+=5*lineasProd.length
                        heightLineaItem=(5*lineasProd.length)
                      }
                      if(heightLineaItem>heightDisponible){
                        posic=35
                        heightDisponible=heightDoc-25
                      }
                      if(lineasProd.length===1){
                        if(lineasUni.length===1){
                          heightDisponible=heightDisponible-5
                        }else{
                          heightDisponible=heightDisponible-(5*lineasUni.length)
                        }            
                      }else{
                        heightDisponible=heightDisponible-(5*lineasProd.length)
                      }
                    }
                  })
  
                  argsUpd.push(iii+1)
                  argsUpd.push(elemento1.descrProductoDes)
                  argsUpd.push(elemento1.cantidad-elemento1.cantidadDev)
                  argsUpd.push(elemento1.descrUnidadDes)
                  argsUpd.push('')
                  argsUpd.push('')
                  tablaRte.push(argsUpd) 
                  argsUpd = []
                }
              })
              
  
              let indice = 0
              let esComp = false
              doc.autoTable({
                startY: 85,
                rowPageBreak: 'avoid',  //cambia de página si la ultima fila queda incompleta
                showHead: 'everyPage',
                tableLineColor: "black",
                tableLineWidth: 0.1,
                styles: {
                  fontSize: 6,
                  lineColor: "black",
                  lineWidth: 0.1,
                  valign: "top",
                },
                headStyles: {
                  fillColor: "#E9E4F0",
                  textColor: "black",
                  halign: "center",
                  valign: "top",
                  cellPadding: 1,
                  fontStyle: "bold",
                  fontSize: 6
                },
                bodyStyles: {
                  // fillColor: "#E9E4F0",
                  fillColor: "white",
                  textColor: "black",
                  halign: "center",
                  minCellHeight: 1
                },
                columnStyles: {
                  0: {cellWidth: 10},
                  1: {cellWidth: 105.7},
                  2: {cellWidth: 13},
                  3: {cellWidth: 13},
                  4: {cellWidth: 20},
                  5: {cellWidth: 28},
                },
  
                didParseCell(data) {
                  if(data.row.index !== -1 && data.section==='body'){
                    data.cell.styles.minCellHeight = 1
                    data.cell.styles.fillColor = "white"
                    data.cell.styles.fontStyle = "normal"
                  }
                },
  
                didDrawCell: (data) => {
                  //imagenes en autoTable
                  //https://github.com/simonbengtsson/jsPDF-AutoTable/issues/93
    if(data.row.index===-1){
    console.log("ojoooo")
    }
                },
                alternateRowStyles: {
                  // fillColor: "white",
                  textColor: "black"
                },
                head: [["ITEM", "DESCRIPCION", "CANTIDAD", "UNIDAD", "RECIBIDO POR", "OBSERVACION"]],
                body: tablaRte,
                margin: {top: 100, left: 12, right: 12, bottom: 25}
              })
  
              // doc.setFillColor('#E9E4F0');
              // doc.lines([[(widthDoc/2)-20,0],[0,5],[0-(widthDoc/2)+20,0]], 12,150, [1,1], 'F', true)
              // doc.lines([[(widthDoc/2)-20,0],[0,5],[0-(widthDoc/2)+20,0]], (widthDoc/2),150, [1,1], 'F', true)
              // doc.setFillColor('#bdc3c7');
  
              posic+=10
              heightDisponible=heightDoc-25-posic
              
              if(heightDisponible<35){
                posic=30
                heightDisponible=heightDoc-25
                doc.addPage()
              }
              doc.setDrawColor('black');
              doc.rect(12, posic, widthDoc-24, 5)
              doc.text(`OBSERVACIONES`, 95, posic+4, 'left')
              doc.rect(12, posic+5, widthDoc-24, 30)
              posic+=35
              heightDisponible=heightDoc-25-posic
  
              if(heightDisponible<50){
                posic=30
                heightDisponible=heightDoc-25
                doc.addPage()
              }
              doc.rect(12, posic, widthDoc-24, 5)   
              doc.text(`INFORMACION DE ACTA DE ENTREGA`, 85, posic+4, 'left')
  
              tablaRte = []
              argsUpd = []
              argsUpd.push('');
              argsUpd.push('');
              tablaRte.push(argsUpd) 
              argsUpd = []
              argsUpd.push('');
              argsUpd.push('');
              tablaRte.push(argsUpd) 
              argsUpd = []
              argsUpd.push('');
              argsUpd.push('');
              tablaRte.push(argsUpd) 
              argsUpd = []  
              argsUpd.push('FIRMA');
              argsUpd.push('FIRMA');
              tablaRte.push(argsUpd) 
              argsUpd = []
              argsUpd.push('Nombre: ' + nombreUsu);
              argsUpd.push('Nombre: ');
              tablaRte.push(argsUpd) 
              argsUpd = []
              argsUpd.push('Cargo: ' + cargoUsu);
              argsUpd.push('Cargo: ');
              tablaRte.push(argsUpd) 
              argsUpd = []
              argsUpd.push('email: ' + mailUsu);
              argsUpd.push('email: ');
              tablaRte.push(argsUpd) 
              argsUpd = []
              argsUpd.push('Teléfono: ' + telefonoUsu);
              argsUpd.push('Teléfono: ');
              tablaRte.push(argsUpd) 
              argsUpd = []
  
              
              doc.autoTable({
                startY: posic+5,
                rowPageBreak: 'avoid',  //cambia de página si la ultima fila queda incompleta
                showHead: 'everyPage',
                tableLineColor: "black",
                tableLineWidth: 0.1,
                styles: {
                  fontSize: 6,
                  lineColor: "black",
                  lineWidth: 0.1,
                  valign: "top",
                },
                headStyles: {
                  fillColor: "#E9E4F0",
                  textColor: "black",
                  halign: "center",
                  valign: "top",
                  cellPadding: 1,
                  fontStyle: "bold",
                  fontSize: 6
                },
                bodyStyles: {
                  // fillColor: "#E9E4F0",
                  fillColor: "white",
                  textColor: "black",
                  halign: "left",
                  minCellHeight: 1
                },
                columnStyles: {
                  0: {cellWidth: 95.6},
                  1: {cellWidth: 95.6},
                },
  
                didParseCell(data) {
                  if(data.row.index !== -1 && data.section==='body'){
                    data.cell.styles.minCellHeight = 1
                    data.cell.styles.fillColor = "white"
                    data.cell.styles.fontStyle = "normal"
                  }
                  if(data.row.index === 0 && data.section==='body'){
                    if(data.column.index === 0 || data.column.index === 1){
                      data.cell.rowSpan = 3
                      data.cell.styles.halign = 'center'
                      data.cell.styles.valign = 'center'
                    }
                  }
                  if(data.row.index === 3 && data.section==='body'){
                    if(data.column.index === 0 || data.column.index === 1){
                      data.cell.styles.halign = 'center'
                      data.cell.styles.valign = 'center'
                    }
                  }
                },
  
                didDrawCell: (data) => {
                  //imagenes en autoTable
                  //https://github.com/simonbengtsson/jsPDF-AutoTable/issues/93
                if(data.row.index===-1){
                console.log("ojoooo")
                }

                if(data.row.index === 0 && data.section==='body' && data.column.index === 0){
                  if(archivoFirma!==''){
                    let imgSourceCB = new Image();
                    imgSourceCB.src = archivoFirma;
                    doc.convertStringToImageData(imgSourceCB)
                    doc.addImage(imgSourceCB, 'PNG', data.cell.x + 26.5, data.cell.y - 2.5, 40, 20);
                  }
                }


                },
                alternateRowStyles: {
                  textColor: "black"
                },
                head: [["CONTRATISTA", "CONTRATANTE"]],
                body: tablaRte,
                margin: {top: 100, left: 12, right: 12, bottom: 25}
              })
  
  
  
  
            const pageCount = doc.internal.getNumberOfPages();
            // For each page, print the page number and the total pages
            for(var i = 1; i <= pageCount; i++) {
                  // Go to page i
                doc.setPage(i);
  
    //ENCABEZADO DE PAGINA
                doc.setFontSize(10);
                doc.setTextColor('black');
                doc.setFontType("bold");
                doc.text(lista[0].descrEmpresa, widthDoc/2, 14, 'center')
                doc.text("REMISION: " + remision, widthDoc/2, 20, 'center')
                doc.setFontSize(8);
  
                let dirSlcm = 'images/logos/LCMSAS.png'
                let logo = ""
                let imgSource = new Image();
                try{
                  imgSource.src = dirSlcm;
                  doc.convertStringToImageData(imgSource)
                  doc.addImage(imgSource, 'PNG', 12, 12, 55, 17);
                }catch{
                  console.log("Logo de LCM no existe")
                }
    //FIN ENCABEZADO DE PAGINA
  
    //PIE DE PAGINA
  
                doc.setFontSize(8);
                doc.setTextColor(255,0,0);
                doc.setFontStyle('Watermark');
                doc.text(empresaWeb, widthDoc/2, heightDoc-15, 'center')
                doc.text("Colombia - Ecuador - Panamá", widthDoc/2, heightDoc-12, 'center')
  
                doc.text('Pag ' + String(i) + ' de ' + String(pageCount), 12, heightDoc-12, 'left')
                doc.text(fechaHoraHoy.substr(0, 10) + " " + fechaHoraHoy.substr(11, 5), widthDoc-50, heightDoc-12, 'left')
                // doc.text('Pag ' + String(i) + ' de ' + String(pageCount),210-20,297-30,null,null,"left");
            }
          let nameDoc = `REMISION_${remision}_${lista[0].descrEmpresa}.pdf`
          document.body.style.cursor = 'default'
          doc.save(nameDoc)

        }else{
          alert("!! No existen registros seleccionados para imprimir !!")
        }
      }else{
        alert("!! No existen registros seleccionados para imprimir !!")
      }
    // }else{
    //   alert("!! Solo se generan remisiones para productos !!")
    // }
  }


  // handleClickidListaE = async (ev, idLista, preguntaE, valoracionE)=>{
  //   ev.preventDefault()
  //   const argsDocum = this.state.argsDocum
  //   argsDocum['valoracion'] = valoracionE
  //   this.setState({preguntaE: preguntaE})
  //   this.setState({argsDocum})
  // }

  handleQuestionUpdDel = async (ev, btn) => {
    var btnPress = await ev.target.attributes[0].value
    if(btnPress==="btnUpdDel" && !this.state.confirmaAct && this.state.procBtn===0){
      this.setState({open: true})
      this.setState({permiteBtn1: btn==="1"?true:false, permiteBtn2: btn==="2"?true:false})
    }else{
      this.setState({open: false})
      this.setState({procBtn: 0})
      this.setState({permiteBtn1: true, permiteBtn2: true})
    };
    if(btnPress==="No"){
      this.setState({open: false})
      this.setState({procBtn: 0})
      this.setState({permiteBtn1: true, permiteBtn2: true})
    };
    if(btnPress==="Si"){
      this.setState({confirmaAct: true})
      this.setState({open: false})
      this.setState({procBtn: 1})
      this.setState({permiteBtn1: btn==="1"?true:false, permiteBtn2: btn==="2"?true:false})
      const myBtn = document.getElementById("btnUpdDel");
      myBtn.click()
    }
  }

  async componentDidUpdate(prevProps, prevState){
      let lista5 = [], lista7 = []
      // console.log(this.props.list5)
      if(this.props.list5!==prevProps.list5){
        if(this.state.ingresa==="S"){
          const elemento3 = this.props.list5
          elemento3.forEach((elemento, i) => {
            lista5.push({numCoti: elemento.numCoti, 
              consecDespacho: elemento.consecDespacho, 
              consecAvance: elemento.consecAvance, 
              descrEmpresa: elemento.descrEmpresa, 
              ordenCompraCliente: elemento.ordenCompraCliente?elemento.ordenCompraCliente:'',
              mail: elemento.mail, 
              ciudad: elemento.ciudad, 
              contacto: elemento.contacto, 
              nombreContacto: elemento.nombreContacto,
              ciudadContacto: elemento.ciudadContacto,
              cargoContacto: elemento.cargoContacto,
              mailContacto: elemento.mailContacto,
              telContacto: elemento.telContacto,
              celular: elemento.celular?elemento.celular:'', 
              descrProducto: elemento.descrProducto,
              numProductoCoti: elemento.numProductoCoti?elemento.numProductoCoti:0,
              cantidadCoti: elemento.cantidadCoti,
              descrUnidad: elemento.descrUnidad,
              cantidadDespacho: elemento.cantidadDespacho, 
              cantidadCompra: elemento.cantidadCompra, cantidadCompraEjec: elemento.cantidadCompraEjec, 
              nuevoValor: 0, nuevoValor2: 0, nuevoValor4: 0, _id: i
            });
          }) 

          const elemento4 = this.props.list7
          elemento4.forEach((elemento, i) => {
            lista7.push({numCoti: elemento.numCoti, 
              numDespacho: elemento.numDespacho, 
              fechaDespacho: elemento.fechaDespacho, 
              descrEmpresa: elemento.descrEmpresa, 
              ordenCompraCliente: elemento.ordenCompraCliente?elemento.ordenCompraCliente:'',
              descrProductoDes: elemento.descrProductoDes,
              idProducto: elemento.idProducto?elemento.idProducto:0,
              cantidad: elemento.cantidad,
              cantidadDev: elemento.cantidadDev?elemento.cantidadDev:0,
              descrUnidadDes: elemento.descrUnidadDes,
              cantidadDev: elemento.cantidadDev, nuevoValor2: 0, nuevoValor3: 0,
              mail: elemento.mail, 
              ciudad: elemento.ciudad, 
              contacto: elemento.contacto, 
              nombreContacto: elemento.nombreContacto,
              ciudadContacto: elemento.ciudadContacto,
              cargoContacto: elemento.cargoContacto,
              mailContacto: elemento.mailContacto,
              telContacto: elemento.telContacto,
             _id: i
            });
          }) 
          console.log(lista7)

          this.setState({lista5, lista7, permiteBtn1: true, open: false, confirmaAct: false, ingresa: "N"})
        }
      }
    
  }

  render (){
    const {checked, argsDocum, confirmaAct, open, preguntaE, permiteBtn1, permiteBtn2} = this.state;
    const a3545 = this.props.autorizacUA.findIndex( autorizac => autorizac === "3545" );
    let estilos = Object.assign({}, this.props.styles.input, {cursor: 'pointer'})

    let mensaje3 = "DESPACHAR "
    let imgIcon3 = "images/archivo_32.png"
    // let mensaje4 = "FACTURAR "
    // let imgIcon4 = "images/archivo_32.png"

    let lista5 = this.state.lista5
    console.log(lista5)
    let lista7 = this.state.lista7
    let pendienteFact = 0, cantidadFact=0
    let pendienteDesp = 0, cantidadDes=0
    let totalFact = 0
    let mensajeDespacho=''
    this.state.lista5.forEach((elemento, i) => {
      cantidadDes+=elemento.cantidadDespacho
      // cantidadFact+=elemento.cantidadFact
      // if(elemento.cantidadDespacho > elemento.cantidadFact){
      //   pendienteFact += elemento.cantidadDespacho - elemento.cantidadFact
      // }
      if(elemento.cantidadCoti > elemento.cantidadDespacho){
        pendienteDesp += elemento.cantidadCoti - elemento.cantidadDespacho
      }
      // if(elemento.porDcto > 0){
      //   totalFact += (elemento.valorDes * elemento.cantidadFact) * (1 - (elemento.porDcto/100))
      // }else{
      //   if(elemento.porIncremento > 0){
      //     totalFact += (elemento.valorDes * elemento.cantidadFact) * (1 + (elemento.porIncremento/100))
      //   }else{
      //     if(elemento.porIncremento > 0){
      //       totalFact += (elemento.valorDes * elemento.cantidadFact)
      //     }
      //   }
      // }
    }) 

    let margen = ''
    if(pendienteDesp>0){
      mensajeDespacho='EXISTEN CANTIDADES PENDIENTES POR DESPACHAR'
      margen = '0.8em 0em 0em 10em'
    }else{
      mensajeDespacho='                        DESPACHO COMPLETADO'
      margen = '0.8em 0em 0em 15em'
    }
    // argsDocum.totalFact = parseInt(totalFact)
    if(checked===true){
      if(pendienteDesp>0){
        argsDocum.estadoCoti = "Aprobada"
      }else{
        argsDocum.estadoCoti='Despachada'
      }
    }else{
      argsDocum.estadoCoti = "Aprobada"
    }

    // let campoAgno = argsDocum.fechaFinReal?argsDocum.fechaFinReal.substring(0, 4):this.props.fechaHoy.substring(0, 4)
    // let campoMes = argsDocum.fechaFinReal?argsDocum.fechaFinReal.substring(5, 7):this.props.fechaHoy.substring(5, 7)
    // let campoDia = argsDocum.fechaFinReal?argsDocum.fechaFinReal.substring(8, 10):this.props.fechaHoy.substring(8, 10)
    // argsDocum.fechaFinReal = campoAgno + '-' + campoMes + '-' + campoDia
    let mensaje1 = ""
    let mensaje2 = "GRABAR RESPUESTA" 

    if(this.props.preguntaE){
      mensaje1 = `Eliminar item de encuesta de la orden de compra ${argsDocum.numOrdenCompra}`
    }else{
      mensaje1 += "(Seleccionar...)"
    }
    let imgIcon1 = "images/archivo_32.png"

    let idOrden = this.props.idLista._id
    let numCoti = this.props.idLista.numCoti

    let list2 = []
    let listCon=[]
    // if (argsDocum.descrEmpresa){
    //   let empre=argsDocum.descrEmpresa
    //   if(this.props.allUsuarios.allUsuarios){
    //     list2 = this.props.allUsuarios.allUsuarios
    //     listCon = list2.filter(elemento => elemento.descrEmpresa===empre && elemento.tipo==='Externo')
    //   }
    // }
    let fechaFinReal = new Date(argsDocum.fechaFinReal)
    fechaFinReal = (fechaFinReal.getFullYear()) + '-' + ((fechaFinReal.getMonth()+1)<10?'0'+(fechaFinReal.getMonth()+1):(fechaFinReal.getMonth()+1)) + '-' + (fechaFinReal.getUTCDate()<10?'0'+fechaFinReal.getUTCDate():fechaFinReal.getUTCDate())
    let fechaEntrega = new Date(argsDocum.fechaEntrega)
    fechaEntrega = (fechaEntrega.getFullYear()) + '-' + ((fechaEntrega.getMonth()+1)<10?'0'+(fechaEntrega.getMonth()+1):(fechaEntrega.getMonth()+1)) + '-' + (fechaEntrega.getUTCDate()<10?'0'+fechaEntrega.getUTCDate():fechaEntrega.getUTCDate())
console.log(argsDocum)
    return(
      <div>
        <button className="ui right labeled icon button" style={this.props.styles.titBuscar}>
          <i className="large hand point down yellow icon"></i>
          Traslados de producto en proceso
        </button>
        <div style={this.props.styles.box}>
          <Form name="form1" id="form1" onSubmit={confirmaAct?
            (ev)=>this.props.handleSubmit(ev, argsDocum):
           ()=>{}} 
          >
            <div className="ui four column stackable grid">
              <div className="row container">
                <div className="column" style={{width: '30%'}}>
                  <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.8em 0em 0em 0em'}}>
                    Empresa: &nbsp;&nbsp;{this.props.idLista.descrEmpresa}
                  </p>                
                </div>
                <div className="column" style={{width: '15%'}}>
                  <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.8em 0em 0em 0em'}}>
                    # Orden cliente: &nbsp;&nbsp;{this.props.idLista.ordenCompraCliente}
                  </p>                
                </div>
                <div className="column" style={{width: '25%'}}>
                  <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.8em 0em 0em 0em'}}>
                    # Solicitud LCM: &nbsp;&nbsp;{this.props.idLista.numCoti}
                  </p>                
                </div>
                <div className="column" style={{width: '30%'}}>
                  <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.8em 0em 0em 0em'}}>
                    Dirección empresa: &nbsp;&nbsp;{this.props.idLista.direccion}
                  </p>                
                </div>
                <div className="column" width='35%'>
                  <Form.Field>
                    <label style={this.props.styles.label}>Fecha de entrega real</label>
                    <input style={this.props.styles} type='date' name="fechaFinReal" id="fechaFinReal" value={fechaFinReal} onChange={this.handleChange}/>
                  </Form.Field>
                </div>
                <div className="column" width="30%">
                  <Form.Field>
                    <label style={this.props.styles.label}>
                      Archivo de informe...&nbsp;&nbsp;
                    </label>
                    <input id="file3" name="file3" type="file" accept=".pdf,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document" multiple={false} style={estilos} onChange={this.handleChange}></input>
                  </Form.Field>  
                </div>
                <div className="column" width="35%"> 
                  <Form.Field>
                    <label style={this.props.styles.label}>Dirección de entrega en guía</label>
                    <Form.Input autoComplete="off" name="dirEntrega" id="dirEntrega" value={argsDocum.dirEntrega} onChange={this.handleChange} placeholder='Dirección de entrega en guía' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'dirEntrega'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                  </Form.Field> 
                </div>
                <div className="column" width="35%"> 
                  <Form.Field>
                    <label style={this.props.styles.label}>Transportadora</label>
                    <Form.Input autoComplete="off" name="transportadora" id="transportadora" value={argsDocum.transportadora} onChange={this.handleChange} placeholder='Transportadora' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'transportadora'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                  </Form.Field> 
                </div>
                <div className="column" width="30%"> 
                  <Form.Field>
                    <label style={this.props.styles.label}>Número de guía</label>
                    <Form.Input autoComplete="off" name="numGuia" id="numGuia" value={argsDocum.numGuia} onChange={this.handleChange} placeholder='Número de guía' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'numGuia'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                  </Form.Field> 
                </div>
                <div className="column" width='35%'>
                  <Form.Field>
                    <label style={this.props.styles.label}>Fecha probable entrega</label>
                    <input style={this.props.styles} type='date' name="fechaEntrega" id="fechaEntrega" value={fechaEntrega} onChange={this.handleChange}/>
                  </Form.Field>
                </div>
                <div className="column" width="35%"> 
                  <Form.Field>
                    <label style={this.props.styles.label}>Email para aviso despacho</label>
                    <Form.Input autoComplete="off" name="emailAviso" id="emailAviso" value={argsDocum.emailAviso} onChange={this.handleChange} placeholder='Email para aviso despacho' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'emailAviso'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                  </Form.Field> 
                </div>
              </div>
            </div>
            <div className="column" width="100%"> 
              <Form.Field>
                <label style={this.props.styles.label}>Observaciones finales</label>
                <Form.Input autoComplete="off" name="observacionesFin" id="observacionesFin" value={argsDocum.observacionesFin} onChange={this.handleChange} placeholder='Observaciones de cierre' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'observacionesFin'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
              </Form.Field> 
            </div>  
            <div className="column" width="100%" align='center'> 
              <Form.Field>
                <label style={{color: 'red', align: 'center', fontSize: '1.3em', fontWeight: 'bold', margin: '0.8em 0em 0em 0em'}}>{mensajeDespacho}</label>
              </Form.Field> 
            </div>  
            {a3545!==-1 &&
              <div className="ui three column stackable grid">
                <div className="row container">
                  <div className="column" style={{width: '3%'}}>
                    {argsDocum.informe && 
                      <Form.Field>
                          <div className="column">
                            <input type='checkbox' id="aprobarOC" name="aprobarOC" style={this.props.styles.input} checked={checked} onChange={this.handleChange}/>
                          </div>
                      </Form.Field>
                    }
                  </div>
                  <div className="column" style={{width: '17%'}}>
                    {argsDocum.informe &&
                      <Form.Field>
                        <div className="column">
                          <p style={{color: '#302b63', fontSize: '1.0em', fontWeight: 'bold', margin: '0.8em 0em 0em 0em'}}>
                            &nbsp;&nbsp;CERRAR TRASLADO
                          </p> 
                        </div>
                      </Form.Field>
                    }
                  </div>
  
                  <div className="column" style={{width: '80%', paddingTop: '0.8em'}}> 
                    <EstaSeguro permiteUpdate={this.props.permiteUpdate} 
                    permiteDelete={this.props.permiteDelete} 
                    open={open} styles={this.props.styles} 
                    handleQuestionUpdDel={this.handleQuestionUpdDel}/>
                  </div>
                  {
                    this.props.errors.length?<Message negative header="Los siguientes errores:"
                    list={this.props.errors.map(error=>`${error.path}: ${error.message}`)} />:null
                  }
                </div>
              </div> 
            }

            <div className="column" width="100%">
                <div style={{height: 'auto', overflow: 'auto'}}>
                  <table className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                    <thead className=''>
                      <tr className=''>
                        <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '7%'}}>Cantidad</th>
                        <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '7%'}}>Unidad</th>
                        <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '40%'}}>Producto</th>
                        <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '7%'}}>Cantidad desp.</th>
                        <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '7%'}}>% Despachado</th>
                        <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '7%'}}>Cant. compra solic.</th>
                        <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '7%'}}>Cant. compra ejec.</th>
                        <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '7%'}}>% Comprado</th>
                        <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '7%'}}>Despachar</th>
                        <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '7%'}}>Compra solic.</th>
                        <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '7%'}}>Compra ejec.</th>
                      </tr>
                    </thead>
                  <Lista2 styles={this.props.styles} listI={lista5} handleChangeDes={this.handleChangeDes}/>
                </table>
                <div className="ui four column stackable grid">
                  <div className="row container">            
                    <div className="column" style={{width: '25%', paddingTop: '0em'}}>
                      <Button id="remision" name="remision" style={{...this.props.styles.confirmar, height: '2.1em'}} onClick={(ev)=>this.handleRemision(ev, lista5, argsDocum)} fluid>
                        REMISION EN BLANCO
                      </Button>
                    </div>
                    <div className="column" style={{width: '25%', paddingTop: '0em'}}>
                      <Button id="despachar" name="despachar" style={{...this.props.styles.confirmar, height: '2.1em'}} onClick={(ev)=>this.handleDespachar(ev, lista5, argsDocum)} fluid>
                        DESPACHAR
                      </Button>
                    </div>
                    <div className="column" style={{width: '25%', paddingTop: '0em'}}>
                      <Button id="comprar" name="comprar" style={{...this.props.styles.confirmar, height: '2.1em'}} onClick={(ev)=>this.handleComprar(ev, lista5, argsDocum)} fluid>
                        SOLICITAR COMPRA
                      </Button>
                    </div> 
                    <div className="column" style={{width: '25%', paddingTop: '0em'}}>
                      <Button id="registrar" name="registrar" style={{...this.props.styles.confirmar, height: '2.1em'}} onClick={(ev)=>this.handleComprarEjec(ev, lista5, argsDocum)} fluid>
                        REGISTRAR COMPRA
                      </Button>
                    </div>                 
                  </div>
                </div>
              </div>
            </div>
            {lista7.length>0 &&
              <div className="column" width="100%" align='center'> 
                <Form.Field>
                  <label style={{color: 'red', align: 'center', fontSize: '1.3em', fontWeight: 'bold', margin: '0.8em 0em 0em 0em'}}>DESPACHOS REALIZADOS</label>
                </Form.Field> 
              </div>
            }
            {lista7.length>0 &&
              <div className="column" width="100%">
                  <div style={{height: 'auto', overflow: 'auto'}}>
                    <table className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                      <thead className=''>
                        <tr className=''>
                          <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '20%'}}>No. Despacho</th>
                          <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '7%'}}>Fecha</th>
                          <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '35%'}}>Producto</th>
                          <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '10%'}}>Unidad</th>
                          <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '7%'}}>Cant. despacho</th>
                          <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '7%'}}>Cant. devuelta</th>
                          <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '7%'}}>Cant. recibida</th>
                          <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '7%'}}>Devolver</th>
                          <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '7%'}}>Imprimir (1)</th>
                        </tr>
                      </thead>
                    <Lista3 styles={this.props.styles} listD={lista7} handleChangeDev={this.handleChangeDev}/>
                  </table>
                  <div className="ui two column stackable grid">
                    <div className="row container">            
                      <div className="column" style={{width: '50%', paddingTop: '0em'}}>
                        <Button id="imprimir" name="imprimir" style={{...this.props.styles.confirmar, height: '2.1em', align: 'center'}} onClick={(ev)=>this.handleImprimir(ev, lista7, argsDocum)} fluid>
                          IMPRIMIR REMISION
                        </Button>
                      </div>
                      <div className="column" style={{width: '50%', paddingTop: '0em'}}>
                        <Button id="devolver" name="devolver" style={{...this.props.styles.confirmar, height: '2.1em', align: 'center'}} onClick={(ev)=>this.handleDevolver(ev, lista7, argsDocum)} fluid>
                          REGISTRAR DEVOLUCION
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            }
            <p></p>
            {/* <div style={{height: '17em', overflow: 'auto'}}>
                <table className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                  <thead className=''>
                    <tr className=''>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '90%'}}>Pregunta</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '10%'}}>Valoración</th>
                    </tr>
                  </thead>
                  <ListaE listE={this.props.list6} handleClickidListaE={this.props.handleClickidListaE} preguntaE={this.props.preguntaE} valoracionE={this.props.valoracionE}/>
                </table>
              <p></p>
            </div> */}
          </Form>
        </div>
      </div>
    )
  }
}

export default compose(
  // graphql(queries.query.allProducto, {name:'allProducto'}),
  graphql(queries.query.allEmpresa, {name:'allEmpresa'}),
  graphql(queries.query.allEmpresaRtes, {name:'allEmpresaRtes',
  options: (props) => {return {variables: {tipoqry: `[{$match: {descrEmpresa: {$ne: 'XXXXXXX'}}}]`}}}}),
  graphql(queries.query.allUsuarios, {name:'allUsuarios'}),
  graphql(queries.query.allUsuariosRtes, {name:'allUsuariosRtes',
  options: (props) => {return {variables: {tipoqry: `[{$match: {nombreUsuario: {$ne: 'XXXXXXX'}}}]`}}}}),
  graphql(queries.query.allCotizacionRtes, {name:'allCotizacionRtes11',
    options: (props) => {return {variables: {tipoqry: `[{$match: {tipoCoti: 'Cliente', estadoOC: 'Aprobada'}}]`}}}}),

  graphql(queries.mutation.editCotizacion, {name:'editCotizacion'}),
  graphql(queries.mutation.fecha, {name:'fecha'}),
  
  graphql(queries.query.getParametro, {name:'getParametro', options: (props) => {return {variables: {}}}}),
  graphql(queries.mutation.createSolicCompra, {name:'createSolicCompra'}),
 graphql(queries.query.allUsuariosRtes, {name:'allUsuariosRtes',
    options: (props) => {return {variables: {tipoqry: `[{$match: {tipo: {$ne: 'Externo'}}}]`}}}}),
  
  graphql(queries.mutation.editSeqfindOneAndUpdate, {name:'editSeqfindOneAndUpdate'}),

)(VerOrdenCompraFin2)
